import script from "./CreateEinvoiceProcurement.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateEinvoiceProcurement.vue?vue&type=script&setup=true&lang=js"

import "./CreateEinvoiceProcurement.vue?vue&type=style&index=0&id=01f0fa7c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01f0fa7c"]])

export default __exports__